/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Showcase_SignInputs */

const en_landing_showcase_sign = /** @type {(inputs: Landing_Showcase_SignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hotel signage`)
};

const zh_landing_showcase_sign = /** @type {(inputs: Landing_Showcase_SignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`酒店标识`)
};

/**
* | output |
* | --- |
* | "Hotel signage" |
*
* @param {Landing_Showcase_SignInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_showcase_sign = /** @type {((inputs?: Landing_Showcase_SignInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Showcase_SignInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_showcase_sign(inputs)
	return zh_landing_showcase_sign(inputs)
});
export { landing_showcase_sign as "landing.showcase.sign" }